import React from 'react';

export function ProductName({ productName }) {

    return (
        <h3>{productName}</h3>
    );
}
